import { render, staticRenderFns } from "./CustomerOptionsCard.vue?vue&type=template&id=2095244e&scoped=true"
import script from "./CustomerOptionsCard.vue?vue&type=script&lang=js"
export * from "./CustomerOptionsCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerOptionsCard.vue?vue&type=style&index=0&id=2095244e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095244e",
  null
  
)

export default component.exports